module.exports = __webpack_public_path__ + "static/media/zhuzijianshan_package.94da5be6.png";